import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useFootprint } from '@/idv2/hooks/use-footprint';
import { markContinueOnMobile } from '@/idv2/index';
import CameraAccessDenied from '../../../components/camera-access-denied';
import CameraAccessRequest from '../../../components/camera-access-request';
import CameraError from '../../../components/camera-error';
import CaptureRetryPrompt from '../../components/capture-retry-prompt';
import useIdDocMachine from '../../hooks/use-id-doc-machine';
import BackPhotoCapture from '../back-photo-capture';
import Consent from '../consent';
import DesktopCapture from '../desktop-capture';
import DesktopProcessing from '../desktop-processing';
import DesktopSelfie from '../desktop-selfie';
import DesktopSelfieRetry from '../desktop-selfie-retry';
import FrontPhotoCapture from '../front-photo-capture';
import IdDocCountryAndType from '../id-doc-country-and-type';
import MobileFallbackUpload from '../mobile-fallback-upload';
import Processing from '../processing';
import SelfiePhoto from '../selfie-photo';
type RouterProps = {
  onDone: () => void;
};
const Router = t0 => {
  const $ = _c(67);
  const {
    onDone
  } = t0;
  const [state, dispatch] = useIdDocMachine();
  const footprint = useFootprint();
  const isDone = state.value === "complete" || state.value === "failure";
  let t1;
  let t2;
  if ($[0] !== isDone || $[1] !== onDone) {
    t1 = () => {
      if (isDone) {
        onDone();
      }
    };
    t2 = [isDone, onDone];
    $[0] = isDone;
    $[1] = onDone;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (state.value === "countryAndType") {
    let t3;
    if ($[4] !== state.context.requirement.config.kind || $[5] !== state.context.requirement.config.supportedCountryAndDocTypes) {
      t3 = state.context.requirement.config.kind === "identity" ? state.context.requirement.config.supportedCountryAndDocTypes : {};
      $[4] = state.context.requirement.config.kind;
      $[5] = state.context.requirement.config.supportedCountryAndDocTypes;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== dispatch) {
      t4 = data => dispatch({
        type: "receivedCountryAndType",
        payload: data
      });
      $[7] = dispatch;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== footprint.navigation) {
      t5 = () => {
        markContinueOnMobile();
        footprint.navigation.forward();
      };
      $[9] = footprint.navigation;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== state.context.authToken || $[12] !== state.context.device || $[13] !== state.context.idDoc.type || $[14] !== state.context.requirement.documentRequestId || $[15] !== state.context.sandboxOutcome || $[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
      t6 = <IdDocCountryAndType authToken={state.context.authToken} device={state.context.device} supportedCountryAndDocTypes={t3} sandboxOutcome={state.context.sandboxOutcome} selectedDocType={state.context.idDoc.type} documentRequestId={state.context.requirement.documentRequestId} onSubmitDocType={t4} onContinueOnMobile={t5} />;
      $[11] = state.context.authToken;
      $[12] = state.context.device;
      $[13] = state.context.idDoc.type;
      $[14] = state.context.requirement.documentRequestId;
      $[15] = state.context.sandboxOutcome;
      $[16] = t3;
      $[17] = t4;
      $[18] = t5;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    return t6;
  }
  if (state.value === "consent") {
    let t3;
    let t4;
    if ($[20] !== dispatch) {
      t3 = () => dispatch({
        type: "consentReceived"
      });
      t4 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[20] = dispatch;
      $[21] = t3;
      $[22] = t4;
    } else {
      t3 = $[21];
      t4 = $[22];
    }
    let t5;
    if ($[23] !== state.context.authToken || $[24] !== state.context.device || $[25] !== state.context.onboardingConfig.logoUrl || $[26] !== state.context.onboardingConfig.orgName || $[27] !== state.context.onboardingConfig.privacyPolicyUrl || $[28] !== t3 || $[29] !== t4) {
      t5 = <Consent authToken={state.context.authToken} device={state.context.device} onConsentSubmit={t3} onNavigatedToPrev={t4} tenantLogoUrl={state.context.onboardingConfig.logoUrl} tenantName={state.context.onboardingConfig.orgName} tenantPrivacyPolicyUrl={state.context.onboardingConfig.privacyPolicyUrl} />;
      $[23] = state.context.authToken;
      $[24] = state.context.device;
      $[25] = state.context.onboardingConfig.logoUrl;
      $[26] = state.context.onboardingConfig.orgName;
      $[27] = state.context.onboardingConfig.privacyPolicyUrl;
      $[28] = t3;
      $[29] = t4;
      $[30] = t5;
    } else {
      t5 = $[30];
    }
    return t5;
  }
  if (state.value === "mobileRequestCameraAccess") {
    let t3;
    if ($[31] !== dispatch) {
      t3 = <CameraAccessRequest onClose={() => dispatch({
        type: "navigatedToPrev"
      })} onCameraAccessDenied={() => dispatch({
        type: "cameraAccessDenied",
        payload: {
          status: "denied"
        }
      })} onCameraError={cause => dispatch({
        type: "cameraErrored",
        payload: {
          cause
        }
      })} onSuccess={() => dispatch({
        type: "cameraAccessGranted",
        payload: {
          status: "granted"
        }
      })} />;
      $[31] = dispatch;
      $[32] = t3;
    } else {
      t3 = $[32];
    }
    return t3;
  }
  if (state.value === "mobileCameraAccessDenied") {
    let t3;
    if ($[33] !== dispatch) {
      t3 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[33] = dispatch;
      $[34] = t3;
    } else {
      t3 = $[34];
    }
    let t4;
    if ($[35] !== state.context.device || $[36] !== t3) {
      t4 = <CameraAccessDenied device={state.context.device} onClose={t3} />;
      $[35] = state.context.device;
      $[36] = t3;
      $[37] = t4;
    } else {
      t4 = $[37];
    }
    return t4;
  }
  if (state.value === "mobileCameraErrored") {
    let t3;
    if ($[38] !== dispatch) {
      t3 = () => dispatch({
        type: "navigatedToPrev"
      });
      $[38] = dispatch;
      $[39] = t3;
    } else {
      t3 = $[39];
    }
    const t4 = state.context.cameraErrorCause ?? "other-error";
    let t5;
    if ($[40] !== t3 || $[41] !== t4) {
      t5 = <CameraError onBack={t3} cause={t4} />;
      $[40] = t3;
      $[41] = t4;
      $[42] = t5;
    } else {
      t5 = $[42];
    }
    return t5;
  }
  if (state.value === "mobileFrontImageCapture") {
    let t3;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FrontPhotoCapture />;
      $[43] = t3;
    } else {
      t3 = $[43];
    }
    return t3;
  }
  if (state.value === "mobileFrontPhotoFallback") {
    let t3;
    if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MobileFallbackUpload imageType="front" />;
      $[44] = t3;
    } else {
      t3 = $[44];
    }
    return t3;
  }
  if (state.value === "mobileFrontImageRetry") {
    let t3;
    if ($[45] !== dispatch) {
      t3 = <CaptureRetryPrompt imageType="front" onComplete={payload => dispatch({
        type: "receivedImage",
        payload
      })} />;
      $[45] = dispatch;
      $[46] = t3;
    } else {
      t3 = $[46];
    }
    return t3;
  }
  if (state.value === "desktopFrontImage") {
    let t3;
    if ($[47] !== dispatch) {
      t3 = <DesktopCapture imageType="front" onBack={() => dispatch({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_0 => dispatch({
        type: "receivedImage",
        payload: payload_0
      })} />;
      $[47] = dispatch;
      $[48] = t3;
    } else {
      t3 = $[48];
    }
    return t3;
  }
  if (state.value === "desktopFrontImageRetry") {
    let t3;
    if ($[49] !== dispatch) {
      t3 = <DesktopCapture imageType="front" isRetry={true} onBack={() => dispatch({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_1 => dispatch({
        type: "receivedImage",
        payload: payload_1
      })} />;
      $[49] = dispatch;
      $[50] = t3;
    } else {
      t3 = $[50];
    }
    return t3;
  }
  if (state.value === "mobileBackImageCapture") {
    let t3;
    if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <BackPhotoCapture />;
      $[51] = t3;
    } else {
      t3 = $[51];
    }
    return t3;
  }
  if (state.value === "mobileBackPhotoFallback") {
    let t3;
    if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MobileFallbackUpload imageType="back" />;
      $[52] = t3;
    } else {
      t3 = $[52];
    }
    return t3;
  }
  if (state.value === "mobileBackImageRetry") {
    let t3;
    if ($[53] !== dispatch) {
      t3 = <CaptureRetryPrompt imageType="back" onComplete={payload_2 => dispatch({
        type: "receivedImage",
        payload: payload_2
      })} />;
      $[53] = dispatch;
      $[54] = t3;
    } else {
      t3 = $[54];
    }
    return t3;
  }
  if (state.value === "desktopBackImage") {
    let t3;
    if ($[55] !== dispatch) {
      t3 = <DesktopCapture imageType="back" onBack={() => dispatch({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_3 => dispatch({
        type: "receivedImage",
        payload: payload_3
      })} />;
      $[55] = dispatch;
      $[56] = t3;
    } else {
      t3 = $[56];
    }
    return t3;
  }
  if (state.value === "desktopBackImageRetry") {
    let t3;
    if ($[57] !== dispatch) {
      t3 = <DesktopCapture imageType="back" isRetry={true} onBack={() => dispatch({
        type: "navigatedToCountryDoc"
      })} onComplete={payload_4 => dispatch({
        type: "receivedImage",
        payload: payload_4
      })} />;
      $[57] = dispatch;
      $[58] = t3;
    } else {
      t3 = $[58];
    }
    return t3;
  }
  if (state.value === "mobileSelfieImage") {
    let t3;
    if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <SelfiePhoto />;
      $[59] = t3;
    } else {
      t3 = $[59];
    }
    return t3;
  }
  if (state.value === "mobileSelfieFallback") {
    let t3;
    if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <MobileFallbackUpload imageType="selfie" />;
      $[60] = t3;
    } else {
      t3 = $[60];
    }
    return t3;
  }
  if (state.value === "mobileSelfieImageRetry") {
    let t3;
    if ($[61] !== dispatch) {
      t3 = <CaptureRetryPrompt imageType="selfie" onComplete={payload_5 => dispatch({
        type: "receivedImage",
        payload: payload_5
      })} />;
      $[61] = dispatch;
      $[62] = t3;
    } else {
      t3 = $[62];
    }
    return t3;
  }
  if (state.value === "desktopSelfieImage") {
    let t3;
    if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <DesktopSelfie />;
      $[63] = t3;
    } else {
      t3 = $[63];
    }
    return t3;
  }
  if (state.value === "desktopSelfieImageRetry") {
    let t3;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <DesktopSelfieRetry />;
      $[64] = t3;
    } else {
      t3 = $[64];
    }
    return t3;
  }
  if (state.value === "mobileProcessing") {
    let t3;
    if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <Processing />;
      $[65] = t3;
    } else {
      t3 = $[65];
    }
    return t3;
  }
  if (state.value === "desktopProcessing") {
    let t3;
    if ($[66] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <DesktopProcessing />;
      $[66] = t3;
    } else {
      t3 = $[66];
    }
    return t3;
  }
  return null;
};
export default Router;